/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */
   
const vatOptions = [
  {
    key: "au_abn",
    value: "au_abn",
    text: "Australian Business Number",
  },
  { key: "br_cnpj", value: "br_cnpj", text: "Brazilian CNPJ number" },
  { key: "br_cpf", value: "br_cpf", text: "Brazilian CPF number" },
  { key: "ca_bn", value: "ca_bn", text: "Canadian BN" },
  { key: "ca_qst", value: "ca_qst", text: "Canadian QST number" },
  { key: "cl_tin", value: "cl_tin", text: "Chilean TIN" },
  { key: "eu_vat", value: "eu_vat", text: "European VAT number" },
  { key: "hk_br", value: "hk_br", text: "Hong Kong BR number" },
  { key: "in_gst", value: "in_gst", text: "Indian GST number" },
  { key: "id_npwp", value: "id_npwp", text: "Indonesian NPWP number" },
  {
    key: "jp_cn",
    value: "jp_cn",
    text: "Japanese Corporate Number",
  },
  { key: "kr_brn", value: "kr_brn", text: "Korean BRN" },
  { key: "li_uid", value: "li_uid", text: "Liechtensteinian UID number" },
  { key: "my_frp", value: "my_frp", text: "Malaysian FRP number" },
  { key: "my_itn", value: "my_itn", text: "Malaysian ITN" },
  { key: "my_sst", value: "my_sst", text: "Malaysian SST number" },
  { key: "mx_rfc", value: "mx_rfc", text: "Mexican RFC number" },
  { key: "nz_gst", value: "nz_gst", text: "New Zealand GST number" },
  { key: "no_vat", value: "no_vat", text: "Norwegian VAT number" },
  { key: "ru_inn", value: "ru_inn", text: "Russian INN" },
  { key: "sa_vat", value: "sa_vat", text: "Saudi Arabia VAT" },
  { key: "sg_gst", value: "sg_gst", text: "Singaporean GST" },
  { key: "sg_uen", value: "sg_uen", text: "Singaporean UEN" },
  { key: "za_vat", value: "za_vat", text: "South African VAT number" },
  { key: "es_cif", value: "es_cif", text: "Spanish CIF number" },
  { key: "ch_vat", value: "ch_vat", text: "Switzerland VAT number" },
  { key: "tw_vat", value: "tw_vat", text: "Taiwanese VAT" },
  { key: "th_vat", value: "th_vat", text: "Thai VAT" },
  { key: "ae_trn", value: "ae_trn", text: "United Arab Emirates TRN" },
  { key: "us_ein", value: "us_ein", text: "United States EIN" },
];

export { vatOptions };
